import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RequiredValidatorDirective} from './required-validator.directive';

@NgModule({
    imports: [
        FormsModule
    ],
    declarations: [RequiredValidatorDirective],
    exports: [RequiredValidatorDirective]
})
export class RequiredValidatorModule {}
